function $d61ed4d3afdadfea$var$clamp(value, min, max) {
    return value < min ? min : value > max ? max : value;
}
class $d61ed4d3afdadfea$var$Vec2 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    clamp(min, max) {
        return new $d61ed4d3afdadfea$var$Vec2($d61ed4d3afdadfea$var$clamp(this.x, min.x, max.x), $d61ed4d3afdadfea$var$clamp(this.y, min.y, max.y));
    }
    distance_squared_to(other) {
        return (this.x - other.x) * (this.x - other.x) + (this.y - other.y) * (this.y - other.y);
    }
    magnitude() {
        return Math.sqrt(this.distance_squared_to(new $d61ed4d3afdadfea$var$Vec2(0, 0)));
    }
    normalized() {
        return new $d61ed4d3afdadfea$var$Vec2(this.x / this.magnitude(), this.y / this.magnitude());
    }
    plus(other) {
        return new $d61ed4d3afdadfea$var$Vec2(this.x + other.x, this.y + other.y);
    }
    times(scalar) {
        return new $d61ed4d3afdadfea$var$Vec2(this.x * scalar, this.y * scalar);
    }
}
function $d61ed4d3afdadfea$export$51479cab8e743335(options) {
    return {
        ball_position: new $d61ed4d3afdadfea$var$Vec2(0, 0),
        ball_velocity: new $d61ed4d3afdadfea$var$Vec2(0, options.ball_initial_speed),
        player_paddle_x: 0,
        ai_paddle_x: 0,
        ...options
    };
}
function $d61ed4d3afdadfea$export$4addf01929e3c8(previous_state, elapsed_time) {
    if ($d61ed4d3afdadfea$export$88a01a05ddd76820(previous_state)) return previous_state;
    const { ball_radius: ball_radius, ball_max_bounce_angle: ball_max_bounce_angle, paddle_width: paddle_width, paddle_height: paddle_height, ai_movement_speed: ai_movement_speed } = previous_state;
    let ball_state = {
        position: previous_state.ball_position.plus(previous_state.ball_velocity.times(elapsed_time)),
        velocity: previous_state.ball_velocity
    };
    ball_state = $d61ed4d3afdadfea$var$handle_ball_collision_with_paddle(ball_radius, ball_max_bounce_angle, ball_state.position, ball_state.velocity, previous_state.player_paddle_x, 1 - previous_state.paddle_height * 0.5, paddle_width, paddle_height);
    ball_state = $d61ed4d3afdadfea$var$handle_ball_collision_with_paddle(ball_radius, ball_max_bounce_angle, ball_state.position, ball_state.velocity, previous_state.ai_paddle_x, -1 + previous_state.paddle_height * 0.5, paddle_width, paddle_height);
    ball_state = $d61ed4d3afdadfea$var$handle_ball_collision_with_walls(ball_radius, ball_state.position, ball_state.velocity);
    return {
        ...previous_state,
        ball_position: ball_state.position,
        ball_velocity: ball_state.velocity,
        ai_paddle_x: previous_state.ai_paddle_x + elapsed_time * $d61ed4d3afdadfea$var$ai_paddle_velocity(ball_radius, ball_max_bounce_angle, ball_state.position, ball_state.velocity, previous_state.player_paddle_x, previous_state.ai_paddle_x, paddle_width, paddle_height, ai_movement_speed)
    };
}
function $d61ed4d3afdadfea$export$88a01a05ddd76820(state) {
    return $d61ed4d3afdadfea$export$b14ee659ac727b39(state) !== null;
}
function $d61ed4d3afdadfea$export$b14ee659ac727b39(state) {
    return state.ball_position.y - state.ball_radius < -1 ? "player" : state.ball_position.y + state.ball_radius > 1 ? "ai" : null;
}
function $d61ed4d3afdadfea$var$handle_ball_collision_with_paddle(ball_radius, ball_max_bounce_radians, ball_position, ball_velocity, paddle_x, paddle_y, paddle_width, paddle_height) {
    const paddle_left = paddle_x - paddle_width * 0.5;
    const paddle_right = paddle_x + paddle_width * 0.5;
    const paddle_bottom = paddle_y - paddle_height * 0.5;
    const paddle_top = paddle_y + paddle_height * 0.5;
    const nearest_paddle_point = ball_position.clamp(new $d61ed4d3afdadfea$var$Vec2(paddle_left, paddle_bottom), new $d61ed4d3afdadfea$var$Vec2(paddle_right, paddle_top));
    const collides = ball_position.distance_squared_to(nearest_paddle_point) < ball_radius * ball_radius;
    if (!collides) return {
        position: ball_position,
        velocity: ball_velocity
    };
    // When there is a collision, separate the ball from the paddle.
    const separation_padding = 0.001;
    const separation_y = ball_velocity.y < 0 ? paddle_top + ball_radius + separation_padding : paddle_bottom - ball_radius - separation_padding;
    const separation_direction = ball_velocity.normalized();
    separation_direction.y *= -1;
    const separation_distance = Math.abs((ball_position.y - separation_y) / separation_direction.y);
    const new_ball_position = ball_position.plus(separation_direction.times(separation_distance));
    // Once the ball is separated, calculate its new velocity after it bounces.
    const center_offset = new_ball_position.x - paddle_x;
    const center_offset_normalized = center_offset / (0.5 * paddle_width);
    const bounce_angle = 0.5 * Math.PI - center_offset_normalized * ball_max_bounce_radians;
    const new_ball_velocity = new $d61ed4d3afdadfea$var$Vec2(Math.cos(bounce_angle), -Math.sign(ball_velocity.y) * Math.sin(bounce_angle)).times(ball_velocity.magnitude());
    return {
        position: new_ball_position,
        velocity: new_ball_velocity
    };
}
function $d61ed4d3afdadfea$var$handle_ball_collision_with_walls(radius, position, velocity) {
    if (position.x - radius < -1) return {
        position: new $d61ed4d3afdadfea$var$Vec2(-1 + radius, position.y),
        velocity: new $d61ed4d3afdadfea$var$Vec2(velocity.x * -1, velocity.y)
    };
    else if (position.x + radius > 1) return {
        position: new $d61ed4d3afdadfea$var$Vec2(1 - radius, position.y),
        velocity: new $d61ed4d3afdadfea$var$Vec2(velocity.x * -1, velocity.y)
    };
    else return {
        position: position,
        velocity: velocity
    };
}
function $d61ed4d3afdadfea$var$ai_paddle_velocity(ball_radius, ball_max_bounce_angle, ball_position, ball_velocity, player_paddle_x, ai_paddle_x, paddle_width, paddle_height, max_velocity) {
    if (ball_velocity.y >= 0) return 0;
    const goal_y = Math.sign(ball_velocity.y);
    const wall_ahead_x = Math.sign(ball_velocity.x);
    const wall_behind_x = -wall_ahead_x;
    const time_to_intercept = (Math.abs(goal_y - ball_position.y) - paddle_height - ball_radius) / Math.abs(ball_velocity.y);
    const horizontal_movement = Math.abs(ball_velocity.x * time_to_intercept);
    const distance_to_wall_ahead = Math.abs(wall_ahead_x - ball_position.x) - ball_radius;
    let intercept_x;
    if (horizontal_movement < distance_to_wall_ahead) intercept_x = ball_position.x + ball_velocity.x * time_to_intercept;
    else {
        const padded_edge_size = 2 - 2 * ball_radius;
        const nr_wall_bounces = Math.floor((horizontal_movement - distance_to_wall_ahead) / padded_edge_size);
        const final_stretch_distance = (horizontal_movement - distance_to_wall_ahead) % padded_edge_size;
        intercept_x = nr_wall_bounces % 2 == 0 ? wall_ahead_x - Math.sign(ball_velocity.x) * final_stretch_distance : wall_behind_x + Math.sign(ball_velocity.x) * final_stretch_distance;
    }
    const target_serve_x = -Math.sign(player_paddle_x) * (1 - ball_radius);
    const target_bounce_angle = Math.atan((target_serve_x - intercept_x) / 2);
    const center_offset_normalized = target_bounce_angle / ball_max_bounce_angle;
    const center_offset = $d61ed4d3afdadfea$var$clamp(center_offset_normalized, -1, 1) * 0.5 * paddle_width;
    const target_x = intercept_x - center_offset;
    const target_dx = target_x - ai_paddle_x;
    return max_velocity * target_dx;
}


function $aa3362e99d164a68$var$draw_game_state(game_state, context, options) {
    context.fillStyle = options.background_color;
    context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    context.save();
    context.scale(context.canvas.width / 2, context.canvas.height / 2);
    context.translate(1, 1);
    context.fillStyle = options.foreground_color;
    context.beginPath();
    context.rect(game_state.player_paddle_x - game_state.paddle_width * 0.5, 1 - game_state.paddle_height, game_state.paddle_width, game_state.paddle_height);
    context.rect(game_state.ai_paddle_x - game_state.paddle_width * 0.5, -1, game_state.paddle_width, game_state.paddle_height);
    context.arc(game_state.ball_position.x, game_state.ball_position.y, game_state.ball_radius, 0, 2 * Math.PI);
    context.fill();
    context.restore();
}
function $aa3362e99d164a68$var$setup() {
    const canvas = document.getElementById("demo-canvas");
    if (!(canvas instanceof HTMLCanvasElement)) throw new Error("cannot find canvas");
    const render_context = canvas.getContext("2d", {
        alpha: false
    });
    if (render_context === null) throw new Error("cannot get context");
    const game_options = {
        ball_radius: 0.05,
        ball_initial_speed: 1.6,
        ball_max_bounce_angle: 0.3 * Math.PI,
        paddle_width: 0.4,
        paddle_height: 0.05,
        ai_movement_speed: 1
    };
    const render_options = {
        background_color: "white",
        foreground_color: "#ed12a5"
    };
    let game_state = (0, $d61ed4d3afdadfea$export$51479cab8e743335)(game_options);
    let last_frame_time_ms = null;
    canvas.addEventListener("mousemove", (event)=>{
        event.preventDefault();
        game_state.player_paddle_x = -1 + event.offsetX / canvas.clientWidth * 2;
    });
    canvas.addEventListener("touchmove", (event)=>{
        const touch = event.touches.item(0);
        if (touch === null) return;
        event.preventDefault();
        const canvas_rect = canvas.getBoundingClientRect();
        game_state.player_paddle_x = -1 + (touch.clientX - canvas_rect.left) / canvas.clientWidth * 2;
    });
    const advance_game = ()=>{
        const this_frame_time_ms = performance.now();
        const elapsed_seconds = last_frame_time_ms ? (this_frame_time_ms - last_frame_time_ms) / 1000 : 0;
        last_frame_time_ms = this_frame_time_ms;
        game_state = (0, $d61ed4d3afdadfea$export$4addf01929e3c8)(game_state, elapsed_seconds);
        $aa3362e99d164a68$var$draw_game_state(game_state, render_context, render_options);
        if ((0, $d61ed4d3afdadfea$export$88a01a05ddd76820)(game_state)) {
            if ((0, $d61ed4d3afdadfea$export$b14ee659ac727b39)(game_state) === "player" && game_options.ball_initial_speed < 3) {
                game_options.ball_initial_speed += 0.2;
                game_options.ai_movement_speed += 0.2;
            }
            game_state = (0, $d61ed4d3afdadfea$export$51479cab8e743335)(game_options);
            last_frame_time_ms = null;
            setTimeout(()=>requestAnimationFrame(advance_game), 1000);
        } else requestAnimationFrame(advance_game);
    };
    advance_game();
}
window.addEventListener("DOMContentLoaded", $aa3362e99d164a68$var$setup);


//# sourceMappingURL=index.d81e8cd7.js.map
